import { FC } from 'react';

import { formatPrice } from '@shared/utils/formatPrice';

import { GiftDeliveryFeePreviewState } from '../hooks/useGiftDeliveryFeePreview';
import { isFreeBaseFeeApplied } from '../utils/giftDeliveryFeePreview.util';

interface IProps {
  deliveryFee: GiftDeliveryFeePreviewState;
}

/**
 * 결제 금액 블록의 "배송비" 줄 — 권역 배송비 대상 주문일 때만 렌더.
 * 배송 가능: 금액(0원은 "무료"), 지역 추가배송비 부연. 배송 불가/주소 불완전: 붉게 표시.
 */
export const GiftDeliveryFeeSummaryRow: FC<IProps> = ({ deliveryFee }) => {
  const { preview, loading } = deliveryFee;
  if (!preview || !preview.applicable) return null;

  if (!preview.deliverable) {
    return (
      <div className="flex justify-between">
        <span className="text-gray-500">배송비</span>
        <span className="text-xs font-bold text-red-500">
          {preview.reason === 'ADDRESS_INCOMPLETE'
            ? '주소 재검색 필요'
            : '배송 불가 지역'}
        </span>
      </div>
    );
  }

  const freeApplied = isFreeBaseFeeApplied(preview);
  // 기본배송비가 붙어 있을 때만 — 무료 기준까지 남은 상품 금액 (자세한 안내·담기 버튼은 배송지 아래)
  const remainingToFree =
    !freeApplied && preview.rule && preview.baseFee > 0
      ? preview.rule.freeOverAmount - preview.subtotal
      : 0;

  return (
    <div className="flex justify-between">
      <span className="text-gray-500">
        배송비
        {preview.extraFee > 0 && (
          <span className="ml-1 text-[11px] text-orange-600">지역 추가배송비 포함</span>
        )}
        {freeApplied && preview.rule && (
          <span className="ml-1 text-[11px] text-green-600">
            {formatPrice(preview.rule.freeOverAmount)}원 이상 무료
          </span>
        )}
        {remainingToFree > 0 && (
          <span className="ml-1 text-[11px] theme-text-main">
            {formatPrice(remainingToFree)}원 더 담으면 기본배송비 무료
          </span>
        )}
      </span>
      <span className={loading ? 'text-gray-400' : ''}>
        {preview.total === 0 ? '무료' : `${formatPrice(preview.total)}원`}
      </span>
    </div>
  );
};
